import { FormFieldTypes } from "../../../data/formFieldType";

const forgetPasswordFormData = {
    name: "Forget Password Form",
    initialState: {
        emailAddress: "",
    },
    formFields: [
        {
            id: "emailAddress",
            lable: "Enter the email to retrieve your account",
            Field_Name: "email address",
            fieldType: FormFieldTypes.INPUT,
            dataField: "emailAddress",
            fieldSetting: {
                placeholder: "Email address",
                allowSpace: true,
            },
            validation: [{ type: "require" }, { type: "email" }],
            style: {
                containerCss: "col-md-12 mb-4"
            }
        },
    ],
};
export default forgetPasswordFormData;
